import { render, staticRenderFns } from "./addCard.vue?vue&type=template&id=6f6532fd&scoped=true&"
import script from "./addCard.vue?vue&type=script&lang=js&"
export * from "./addCard.vue?vue&type=script&lang=js&"
import style0 from "./addCard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./addCard.vue?vue&type=style&index=1&id=6f6532fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6532fd",
  null
  
)

export default component.exports